module.exports = __webpack_public_path__ + "img/apple_icon.87a68d2f.svg";